import styled from 'styled-components';

const StyledClockHelper = styled.section.attrs(() => ({
  className: '',
}))`
  display: flex;
  & > .clock-helper-icon {
    display: flex;
    justify-content: center;
    /* margin-top: 4px; */
    & > img {
      height: 16px;
    }
  }
  & > .clock-helper-content {
    margin-left: 6px;
    color: ${(props) => (props.messageTextColor ? props.messageTextColor : 'red')};
  }
  & .clock-helper__text {
    margin: 0px 4px;
  }
  & .ClockHelper__seconds {
    font-weight: bold;
  };
  & .ClockHelper__minutes {
    font-weight: bold;
  }
  & .ClockHelper__seconds:before {
    content: ":";
  }
  & .clock-helper__btn--retry {
    border: 0;
    padding: 0;
    font-weight: bold;
    color: ${(props) => (props.buttonTextColor ? props.buttonTextColor : 'red')};
    text-decoration: underline;
    background-color: transparent;
    cursor: pointer;
  }
`;

export default StyledClockHelper;
